import { useEffect, useState } from "react"
import classNames from "./styles.module.scss"

interface LayersActive {
  regions: boolean,
  municipals: boolean,
  settlement: boolean,
  cities: boolean,
  localities: boolean,
  streets: boolean,
  houses: boolean,
}

const orderedLayers = ['regions', 'municipals', 'settlement', 'cities', 'localities', 'streets', 'houses'];

const layerNames = {
  regions: 'Регионы',
  municipals: 'Муниципалитеты',
  settlement: 'Поселения',
  cities: 'Города',
  localities: 'Населенные пункты',
  streets: 'Улицы',
  houses: 'Дома',
}


export const LayersFilter = (props: { baseLayersContainer: any, setBaseLayers: Function, setOpened: boolean, layersActive: LayersActive, setActive: Function }) => {

  const [top, setTop] = useState<number>(0)
  const [left, setLeft] = useState<number>(0)

  const [layersState, SetLayersState] = useState<LayersActive>()

  useEffect(() => {
    SetLayersState(props.layersActive)
  }, [props.layersActive])

  useEffect(() => {
    let icon = document.getElementById('mapButton')
    if (icon && props.setOpened) {
      icon.offsetTop && setTop(icon.offsetTop)
      icon.offsetLeft && setLeft(icon.offsetLeft + 170)
    }
  }, [props.setOpened])

  return <>
    {props.setOpened && top > 0 && left > 0 &&
      <>
        <div id='filters' style={{ top: top + 75 + 'px' }} className={classNames.filters}>
          <div className={classNames.baseCont}>{props.baseLayersContainer && props.baseLayersContainer.map((layer:any, i:number) => (
            <p
            key={i + 'button'}
            onClick={(e) => {
              let layers = props.baseLayersContainer.slice()
              layers.forEach((layer2:any) => {
                if(layer2 === layer) layer2.turned = true
                else layer2.turned = false
              });
              props.setBaseLayers(layers)
            }}
            className={classNames.filtersButton + ' ' + (layer.turned ? classNames.active : '')}
          >{layer.label}</p>
          ))}</div>
          {orderedLayers.map((layer, i) => (
            <p
              key={i + 'button'}
              onClick={() => {
                let newButtons: LayersActive = {} as LayersActive;
                newButtons[layer as keyof LayersActive] = true;
                SetLayersState(newButtons)
                props.setActive(newButtons)
              }}
              className={classNames.filtersButton + ' ' + (layersState && layersState[layer as keyof LayersActive] ? classNames.active : '')}
            >{layerNames[layer as keyof LayersActive]}</p>
          ))}
        </div>
        <div style={{ top: top + 40 + 'px', left: left + 'px' }} className={classNames.triangle} />
      </>}
  </>
}




/*
export const LayersFilter = (props: { setOpened: boolean, layersActive: LayersActive, setActive: Function }) => {

  const [top, setTop] = useState<number>(0)
  const [left, setLeft] = useState<number>(0)

  const [buttonsArray, SetButtonsArray] = useState([
    {
      name: 'Регионы',
      on: false
    },
    {
      name: 'Муниципалитеты',
      on: false
    },
    {
      name: 'Поселения',
      on: false
    },
    {
      name: 'Города',
      on: false
    },
    {
      name: 'Населенные пункты',
      on: false
    },
    {
      name: 'Улицы',
      on: false
    },
    {
      name: 'Дома',
      on: false
    }
  ])

  useEffect(() => {
    SetButtonsArray([
      {
        name: 'Регионы',
        on: props.layersActive.regions
      },
      {
        name: 'Муниципалитеты',
        on: props.layersActive.municipals
      },
      {
        name: 'Поселения',
        on: props.layersActive.settlement
      },
      {
        name: 'Города',
        on: props.layersActive.cities
      },
      {
        name: 'Населенные пункты',
        on: props.layersActive.localities
      },
      {
        name: 'Улицы',
        on: props.layersActive.streets
      },
      {
        name: 'Дома',
        on: props.layersActive.houses
      }
    ])
  }, [props.layersActive])

  let setNewProps = (array: Array<any>) => {
    let newLayerFilter: LayersActive = Object.assign({}, props.layersActive)
    array.forEach((layer) => {
      switch (layer.name) {
        case 'Регионы':
          newLayerFilter.regions = layer.on
          break;
        case 'Муниципалитеты':
          newLayerFilter.municipals = layer.on
          break;
        case 'Поселения':
          newLayerFilter.settlement = layer.on
          break;
        case 'Города':
          newLayerFilter.cities = layer.on
          break;
        case 'Населенные пункты':
          newLayerFilter.localities = layer.on
          break;
        case 'Улицы':
          newLayerFilter.streets = layer.on
          break;
        case 'Дома':
          newLayerFilter.houses = layer.on
          break;
        default:
          break;
      }
    })
    props.setActive(newLayerFilter)
  }

  useEffect(() => {
    let icon = document.getElementById('mapButton')
    if (icon && props.setOpened) {
      icon.offsetTop && setTop(icon.offsetTop)
      icon.offsetLeft && setLeft(icon.offsetLeft + 170)
    }
  }, [props.setOpened])

  return <>
    {props.setOpened && top > 0 && left > 0 &&
      <>
        <div id='filters' style={{ top: top + 75 + 'px' }} className={classNames.filters}>
          {buttonsArray.map((button, i) => {
            return <p key={i + 'button'} onClick={() => {
              const newArr = [...buttonsArray];
              newArr.forEach((layer, i2) => {
                if (i === i2) layer.on = !button.on
                else layer.on = false
              })
              setNewProps(newArr)
            }}
              className={classNames.filtersButton + ' ' + (button.on ? classNames.active : '')}>{button.name}</p>
          })
          }
        </div>
        <div style={{ top: top + 40 + 'px', left: left + 'px' }} className={classNames.triangle} />
      </>}
  </>

}

*/